import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";
import React, { useEffect, useRef, useState } from "react";
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, LineController, Tooltip, Legend, } from "chart.js";
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, LineController, Tooltip, Legend);

const OtherAssessment = () => {
  const [otherAssessments, setOtherAssessments] = useState<any[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [selectedAssessment, setSelectedAssessment] = useState("");
  const selectedStatus = "Pass";
  const [assessmentData, setAssessmentData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [summary, setSummary] = useState({
    totalMarks: 0,
    passMarks: 0,
    obtainedMarks: 0,
  });
  const loadOtherAssessments = async () => {
    setIsLoading(true);
    try {
      const response = await serviceApi.get(environment.otherAssessments);

      const data = response.objectData;
      setAssessmentData(data);
      const categoryList = Object.keys(data)
        .filter((key) => key.endsWith("Results"))
        .map((key) => key.replace("Results", "").toUpperCase());
      setCategories(categoryList);
      if (categoryList.length > 0) {
        setSelectedAssessment(categoryList[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  const [progress, setProgress] = useState(0);
  const [graphData, setGraphData] = useState<any[]>([]);
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart<"line"> | null>(null);
  const [expandedWeeks, setExpandedWeeks] = useState<string[]>([]);

  useEffect(() => {
    loadOtherAssessments();
  }, []);

  useEffect(() => {
    if (!selectedAssessment || Object.keys(assessmentData).length === 0) return;
    const key = `${selectedAssessment.toLowerCase()}Results`;
    const assessments = assessmentData[key] || [];
    setOtherAssessments(assessments);
    applyFilter(assessments);
  }, [selectedAssessment, assessmentData,]);

  useEffect(() => {
    if (!chartRef.current || graphData.length === 0) return;
    chartInstance.current?.destroy();
    chartInstance.current = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels: graphData.map((x) => x.label),
        datasets: [
          {
            label: "Percentage (%)",
            data: graphData.map((x) => x.percentage),
            borderColor: "#1976d2",
            backgroundColor: "#1976d2",
            pointBackgroundColor: "#ff9800",
            pointBorderColor: "#ff9800",
            pointRadius: 4,
            pointHoverRadius: 6,
            tension: 0.4,
          },
        ],
      },

      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              callback: function (value) {
                return value + "%";
              },
            },
            title: {
              display: true,
              text: "Percentage",
            },
          },
          x: {
            title: {
              display: true,
              text: "Assessments",
            },
          },
        },
      },
    });
    return () => {
      chartInstance.current?.destroy();
    };
  }, [graphData]);

  const applyFilter = (assessmentList: any[]) => {
    const sortedList = [...assessmentList].sort(
      (a, b) =>
        Number(a.examName.replace(/\D/g, "")) -
        Number(b.examName.replace(/\D/g, ""))
    );
    let totalMarks = 0;
    let passMarks = 0;
    let obtainedMarks = 0;
    sortedList.forEach((week) => {
      week.subjects.forEach((subject: any) => {
        totalMarks += subject.maximumMarks;
        obtainedMarks += subject.securedMarks;
        passMarks += Math.floor(subject.maximumMarks * 0.25);
      });
    });

    setSummary({ totalMarks, passMarks, obtainedMarks });
    const percentage =
      totalMarks > 0
        ? Math.round((obtainedMarks / totalMarks) * 100)
        : 0;

    setProgress(percentage);
    setGraphData(
      sortedList.map((item) => ({
        label: item.examName,
        percentage:
          item.totalMarks > 0
            ? Number(
              (
                (item.obtainedMarks /
                  item.totalMarks) *
                100
              ).toFixed(1)
            )
            : 0,
      }))
    );
  };

  const toggleWeek = (week: string) => {
    setExpandedWeeks((prev) =>
      prev.includes(week)
        ? prev.filter((w) => w !== week)
        : [...prev, week]
    );
  };

  return (<>
    <div className="title-text" style={{ marginBottom: 0, textAlign: "center", fontSize: "20px", padding: "12px 12px 0 12px", }}>
      Other Assessment
    </div>

    {/* Loading Other Assessments... */}
    {isLoading && (
      <div className="loading-overlay">
        <div className="loading-overlay__content">
          <div className="spinner spinner--lg"></div>
          <span className="loading-text">Loading Other Assessments...</span>
        </div>
      </div>
    )}
    {/* Assessment Buttons */}
    <div style={{ display: "flex", justifyContent: "space-around", marginTop: "15px", }}>
      {categories.map((item) => (
        <button
          key={item} onClick={() => setSelectedAssessment(item)}
          style={{
            padding: "8px 30px", borderRadius: "20px", border: "1px solid var(--colorPrimaryDark)", cursor: "pointer", background: selectedAssessment === item ? "var(--colorPrimaryDark)" : "#f5eeee", color: selectedAssessment === item ? "#fff" : "#000",
          }}>
          {item}
        </button>
      ))}
    </div>
    <div className="event-container" style={{ cursor: "pointer", margin: "10px" }}>
      {/* Status Buttons */}
      {/* <div
        style={{
          display: "flex",
          textAlign: "center",
          padding: "12px",
          color: "#black",
        }}
      >
        <div style={{ flex: 1, fontSize: "20px", fontWeight: "bold" }}>
          Maximum marks - {summary.totalMarks}
        </div>
        <div style={{ flex: 1, fontSize: "22px", fontWeight: "bold", color: "#0dad43", }}>
          Pass Marks - {summary.passMarks}
        </div>
        <div style={{ flex: 1, fontSize: "22px", fontWeight: "bold" }}>
          Obtained Marks - {summary.obtainedMarks}
        </div>
      </div> */}

      {/* Progress Circle */}
      <div style={{ textAlign: "center", marginTop: "25px" }}>
        <div
          style={{
            width: "90px",
            height: "90px",
            margin: "0 auto",
            borderRadius: "50%",
            background: `conic-gradient(#198754 0deg ${progress * 3.6
              }deg, #e5e5e5 ${progress * 3.6}deg 360deg)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {progress}%
          </div>
        </div>

        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          {selectedAssessment} - Performance
        </div>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: "700px",
          height: "240px",
          margin: "30px auto"
        }}
      >
        <canvas ref={chartRef}></canvas>
      </div>
      <div style={{ marginTop: 4 }}>
        {[...otherAssessments]
          .sort(
            (a, b) =>
              Number(a.examName.replace(/\D/g, "")) -
              Number(b.examName.replace(/\D/g, ""))
          )
          .map((week) => (
            <div
              key={week.examName}
              style={{
                marginBottom: 12,
                border: "1px solid #ddd",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <div
                onClick={() => toggleWeek(week.examName)}
                style={{
                  background: "var(--colorPrimaryDark)",
                  color: "#fff",
                  padding: "12px 15px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <span>{week.examName}</span>
                <span>
                  <i className={`fa-solid ${expandedWeeks.includes(week.examName) ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                </span>
              </div>
              {expandedWeeks.includes(week.examName) && (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    // textAlign: "center",
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f5f5f5" }}>
                      <th>Subject</th>
                      <th>Marks</th>
                      <th>Score</th>
                      <th>Percentage(%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {week.subjects.map((subject: any) => (
                      <tr key={subject.subjectName}>
                        <td style={{ paddingLeft: "20px" }}>{subject.subjectName}</td>
                        <td style={{ textAlign: 'center' }}>{subject.maximumMarks}</td>
                        {/* <td style={{ textAlign: "center" }}>{Math.round(subject.maximumMarks * 0.25)}</td> */}
                        <td style={{ textAlign: 'center' }}>{subject.securedMarks}</td>
                        <td style={{ textAlign: 'center' }}>{Math.round((subject.securedMarks / subject.maximumMarks) * 100)} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
      </div>
    </div>
  </>
  );
};
export default OtherAssessment;